import { Grid, Typography, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import { useHistory } from 'react-router-dom'
import { ButtonView } from '../../../control/button/button'

type OrderProps = {
    index: number
    approveStatusID: number
    nameTH: string
    nameEN: string
    order: number
}

const Order = ({ index, approveStatusID, nameTH, nameEN, order }: OrderProps) => {
    const translate = useTranslate()
    const history = useHistory()
    const classes = useStyles()

    const onEdit = () => {
        history.push(`/setting-consideration/${approveStatusID}/edit`)
    }

    return (
        <div className={classes.item} key={approveStatusID}>
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <ButtonView className={classes.btnEdit} onClick={onEdit}>
                        {translate.get('BUTTON.EDIT')}
                    </ButtonView>
                </Grid>

                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTING_CONSIDERATION.TABLE.no')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{`${order}`}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTING_CONSIDERATION.TABLE.nameTH')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameTH}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTING_CONSIDERATION.TABLE.nameEN')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameEN}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
const useStyles = makeStyles((theme) => ({
    item: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    name: {
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Order
